import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "../../router";

const mountRootComponent = () => {
  const rootNode = document.getElementById("app-container");
  if (!rootNode) {
    throw new Error("Root node not found");
  }
  createRoot(rootNode).render(<RouterProvider router={router} />);
};

export function renderRootComponent() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountRootComponent, { once: true });
    return;
  }
  mountRootComponent();
}
